import { withBaseMultiSelect } from "shared/HOC";

const DEFAULT_CUTS = [
  { value: 'C-Collar', label: 'C-Collar' },
  { value: 'V-Collar', label: 'V-Collar' },
  { value: 'Turtle Neck', label: 'Turtle Neck' },

  { value: 'Classic', label: 'Classic' },
  { value: 'Cropped', label: 'Cropped' },
  { value: 'Cardigan', label: 'Cardigan' },
  { value: 'Long', label: 'Long' },

  { value: 'Classic Length', label: 'Classic Length' },
  { value: 'High Waist', label: 'High Waist' },
  { value: 'Jumper', label: 'Jumper' },
  { value: 'Long Line', label: 'Long Line' },
  { value: 'Loose', label: 'Loose' },
  { value: 'Oversized', label: 'Oversized' },
  { value: 'Short', label: 'Short' },
  { value: 'Tight', label: 'Tight' }
];
const CutSelect = withBaseMultiSelect(DEFAULT_CUTS);
export default CutSelect;
